import React, { useEffect, useRef, useState } from 'react';

export default function HeroSection() {
  const videoRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false); // State to track if the video is loaded

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current
        .play()
        .catch((error) => console.log('Video play failed:', error));
    }
  }, []);

  const scrollDown = () => {
    const section = document.getElementById('locations');
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div
      style={{
        height: '100vh',
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
      }}
      id='home'
    >
      <div>
        {/* Image for Large and Medium Screens */}
        <div
          className='hidden md:block'
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: '20',
          }}
        >
          <picture>
            <source srcSet='/images/IMG_3381.webp' type='image/webp' />
            <img
              src='/images/IMG_3381.jpg'
              alt='Loading...'
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </picture>
        </div>

        {/* Image for Small Screens */}
        <div
          className='block md:hidden'
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: '20',
          }}
        >
          <picture>
            <source srcSet='/images/IMG_3528.webp' type='image/webp' />
            <img
              src='/images/IMG_3528.png'
              alt='Loading...'
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </picture>
        </div>
      </div>
      {/* <video
        key={Date.now()}
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        preload='none'
        onLoadedData={() => setVideoLoaded(false)}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: '10',
        }}
      >
        <source src='/videos/commercial.mp4' type='video/mp4' />
        Your browser does not support the video tag.
      </video> */}
      {/* Overlay Content */}
      <div
        className='relative z-20 flex flex-col items-center justify-center h-full'
        style={{ textAlign: 'center' }}
      >
        <div
          id='order-cta'
          onClick={() => scrollDown()}
          className='flex flex-col items-center justify-center'
        >
          <label
            className='text-white text-4xl md:text-6xl slavic-font cursor-pointer
              text-[30px] sm:text-[40px] md:text-[50px] lg:text-[65px] px-4 py-2 rounded-lg'
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Transparent black background
            }}
          >
            ПОРУЧИ
          </label>

          {/* Downward Arrow */}
          <div className='mt-6 cursor-pointer'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-12 w-12 text-yellow-400 animate-bounce'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
              strokeWidth={2}
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M19 9l-7 7-7-7'
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
